import React from 'react';
import { createRoot } from 'react-dom/client';

import * as serviceWorker from './serviceWorker';
import { Bootstrap } from './bootstrap';

import './index.scss';

const container = document.getElementById('root');

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Bootstrap />
  </React.StrictMode>
);

serviceWorker.unregister();